import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as api from '../utils/api';
import * as storage from '../utils/storage';
import useAuthStore from '../stores/useAuthStore';

const KEY = ['tags'];

function normalize(t) { return { ...t, id: t.tagId || t.id }; }

export function useTags() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  return useQuery({
    queryKey: KEY,
    enabled: isAuthenticated,
    queryFn: async () => {
      const tags = await api.fetchTags();
      const normalized = tags.map(normalize);
      storage.saveTags(normalized);
      return normalized;
    },
    initialData: () => {
      const local = storage.loadTags?.() || [];
      return local.length ? local.map(normalize) : undefined;
    },
  });
}

export function useCreateTag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (tag) => api.createTag(tag),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteTag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.deleteTag(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY });
      qc.invalidateQueries({ queryKey: ['tasks'] });
    },
  });
}
